import React from 'react';
import { motion } from 'framer-motion';
import { 
  Brain, 
  Package, 
  Info, 
  Shield, 
  Lightbulb, 
  Mail,
  Settings,
  HelpCircle
} from 'lucide-react';

const ActionButtons = ({ onButtonClick, systemSettings, darkMode }) => {
  const activeButtons = systemSettings?.actionButtons?.filter(button => button.active) || [];

  if (activeButtons.length === 0) return null;

  const getButtonIcon = (key) => {
    switch (key) {
      case 'ai-solutions':
        return <Brain className="w-4 h-4 sm:w-5 sm:h-5" />;
      case 'products':
        return <Package className="w-4 h-4 sm:w-5 sm:h-5" />;
      case 'about':
        return <Info className="w-4 h-4 sm:w-5 sm:h-5" />;
      case 'private-ai':
        return <Shield className="w-4 h-4 sm:w-5 sm:h-5" />;
      case 'ai-usecases':
        return <Lightbulb className="w-4 h-4 sm:w-5 sm:h-5" />;
      case 'contact':
        return <Mail className="w-4 h-4 sm:w-5 sm:h-5" />;
      default:
        return <HelpCircle className="w-4 h-4 sm:w-5 sm:h-5" />;
    }
  };

  return (
    <div className="p-3 sm:p-4 border-t border-gray-200/30">
      <div className="grid grid-cols-3 sm:grid-cols-6 lg:grid-cols-6 gap-2 sm:gap-3">
        {activeButtons.map((button, index) => (
          <motion.button
            key={index}
            onClick={() => onButtonClick(button.text, button.key)}
            className={`p-3 sm:p-4 rounded-lg font-medium transition-all duration-200 flex items-center justify-center border ${
              darkMode 
                ? 'text-gray-300 hover:text-white hover:bg-white/10 border-gray-600/30 hover:border-gray-500/50' 
                : 'text-gray-600 hover:text-gray-800 hover:bg-black/10 border-gray-300/30 hover:border-gray-400/50'
            }`}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            title={button.text}
          >
            {getButtonIcon(button.key)}
          </motion.button>
        ))}
      </div>
    </div>
  );
};

export default ActionButtons; 